export default {
    ReadUserList(action, self,  OnReadSuccess, onReadFailed) {
        return {
            data : {          
              AuthorizationToken : self.props.UserReducer.token,
            },
            self : self,
            action : action,
            onsuccess : OnReadSuccess,
            onfailed : onReadFailed,
       }
    },
    ReadUserBot(action, self,  OnReadSuccess, onReadFailed) {
      return {
        data : {          
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        action : action,
        onsuccess : OnReadSuccess,
        onfailed : onReadFailed,
      }
    },
    ReadUserChatSummary(action, self,  OnReadSuccess, onReadFailed) {
      return {
        data : {          
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        action : action,
        onsuccess : OnReadSuccess,
        onfailed : onReadFailed,
      }
    },
    ReadChatMessage(action, self,  OnReadSuccess, onReadFailed, userData, nextUrl = null){
        return {
            data : {          
              AuthorizationToken : self.props.UserReducer.token,
              UserData : userData,
              NextUrl : nextUrl
            },
            self : self,
            action : action,
            onsuccess : OnReadSuccess,
            onfailed : onReadFailed,
       }
    },
    RegisterChatMessage(action, self,  OnReadSuccess, onReadFailed){
        return {
            data : {          
              AuthorizationToken : self.props.UserReducer.token,
              Content : self.RegisterParams.Content,
              ToUser : self.RegisterParams.ToUser
            },
            self : self,
            action : action,
            onsuccess : OnReadSuccess,
            onfailed : onReadFailed,
       }
    },
}


// WEBPACK FOOTER //
// ./src/App/chat/ChatSidebar/helper/request.props.js